import { Component , EventEmitter, Injectable, Input, Output, TemplateRef} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ReactiveFormsModule , } from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { Button } from '../button/button.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { Datepicker } from "../datepicker/datepicker.component";
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { Select } from '../select/select.component';
import { Divider } from '../divider/divider.component';
import { ActivatedRoute } from '@angular/router';
import { FieldConfig, FieldValueEmit, FormField } from '../../../constants/form.constants';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    Datepicker,
    MatSelectModule,
    MatDatepickerModule,
    MatGridListModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule
],
  templateUrl: './form.html',
  styleUrl: './form.scss'
})
export class Form {
    get normalFields() {
      return this.sortedFields().filter(f => f.type !== 'checkbox');
    }
    get checkboxFields() {
      return this.sortedFields().filter(f => f.type === 'checkbox');
    }
  form: FormGroup;
  submited : boolean = false;
  selectOptionsFiltered : { [key: string]: any[] } = {};
  selectInput: string = '';
  @Input() fields :FieldConfig =  {};
  @Input() data :string[] = [];
  @Input() validation : boolean = true;
  @Input() backUrl !: string;
  @Input() templateCustom!: TemplateRef<any>;
  @Output() submitForm = new EventEmitter<any>();
  @Output() selectFieldValueEmit = new EventEmitter<FieldValueEmit>();
  @Input() value !: FieldConfig
  @Input() isLoading: boolean = false;
  originalOptionsMap: { [key: string]: any[] } = {};
  parentPath : string = '';
  errorMessages: { [key: string]: string } = {
    required: 'Este campo es obligatorio',
    minlength: 'Se debe ingresar más de un caracter',
    maxlength: 'Se debe ingresar menos de',
  };

  constructor(private fb: FormBuilder,private route: ActivatedRoute) {
    this.form = this.fb.group({});
  }
  addControls(){
    //add controls dinamically by field.validations
    const fields = this.sortedFields();
    fields.forEach(field => {
      let initialValue;
      if (field.name === 'fecha_alta') {
        // Si el campo es fecha_alta y no tiene valor por defecto, asignar la fecha de hoy
        initialValue = field.default !== undefined ? field.default : new Date();
      } else {
        initialValue = field.default !== undefined ? field.default : '';
      }
      this.form.addControl(field.name, this.fb.control(initialValue, field.validations));
    });
  }
  sortedFields() {
    //convert field object to array with index name and value fields data to use in render view
    return Object.entries(this.fields)
      .sort((a, b) => a[1].position - b[1].position)
      .map(([name, field]) => ({
        name,
        ...field,
        isRequired: Array.isArray(field.validations) && field.validations.some(v => v.name === 'required')
      }));
  }
  ngOnInit(){
    this.addControls()
  }
  onSubmit() {
    this.submited = true;
    Object.values(this.form.controls).forEach(control => control.markAsTouched());
    if (this.form.valid) {
      // Se crea una copia del valor del formulario
      const rawValue = { ...this.form.value };
      // Limpia los null y los convierte en undefined
      Object.keys(rawValue).forEach(key => {
        const val = rawValue[key];
        // Si es un objeto tipo {label, value}, lo reemplaza por value
        if (val && typeof val === 'object' && 'label' in val && 'value' in val) {
          rawValue[key] = val.value;
        }
        // Si es null, lo convierte en undefined
        if (val === null) {
          rawValue[key] = undefined;
        }
      });
      return rawValue;
    }
  }
  getErrorMessage(campo: string): string {
    const control = this.form.get(campo);
    let firstKey: string | undefined;
    if (control && control.errors) {
      firstKey = Object.keys(control.errors).find(key => this.errorMessages[key]);
      return firstKey ? this.errorMessages[firstKey] : '';
    }
    return '';
  }
  getFormControl(field: string): FormControl {
    return this.form.get(field) as FormControl;
  }
  selectValueEvent(fieldValue:FieldValueEmit){
    this.selectFieldValueEmit.emit(fieldValue);
  }
  getFieldRows(fields: any[], maxPerRow = 3): any[][] {
  const rows = [];
  for (let i = 0; i < fields.length; i += maxPerRow) {
    rows.push(fields.slice(i, i + maxPerRow));
  }
  return rows;
}
// Método para limpiar el formulario
  reset() {
    this.form.reset();
    this.submited = false;
  }
  filterAutoComplete(valor: string,originalOptions: any[] , field:string) {
    // Ahora recibe el nombre del campo como tercer argumento
    // Uso para filtrar opciones por campo
    // (debe llamarse con field.name en el HTML)
    // filterAutoComplete(valor, opciones, field.name)
    const filtro = valor?.toLowerCase() || '';
    if(!this.originalOptionsMap[field]){
      // Guardamos las opciones originales la primera vez que se filtra
      this.originalOptionsMap[field] = originalOptions;
    }
    this.selectOptionsFiltered[field] = this.originalOptionsMap[field].filter((t: any) => t.label.toLowerCase().includes(filtro));

  }
  selectValueAutoEvent(event: any , options: any[] , field:string) {
    // Al seleccionar, asigna el objeto completo al control
    const seleccionado = event.option.value;
    if (seleccionado) {
      this.form.get(field)?.setValue(seleccionado);
      this.selectFieldValueEmit.emit({ field, value: seleccionado.value });
    }
  }
  displayLabel(event:any) {
    // Para mat-autocomplete displayWith
    return event && typeof event === 'object' && 'label' in event ? event.label : '';
  }
  // En form.component.ts
  patchFormValues(model: any) {
    const patch: any = { ...model };
    // Recorre los campos y transforma solo los de tipo select
    //Para que sean reconocidos por el autocomplete al precargar los datos del modelo a editar
    Object.entries(this.fields).forEach(([fieldName, fieldConfig]: [string, any]) => {
      if (fieldConfig.type === 'select') {
        const options = fieldConfig.options as any[];
        if(!options) return;
        const option = options.find(opt => opt.value === patch[fieldName]);
        patch[fieldName] = option;
      }
    });
    if(this.form) {
      this.form.patchValue(patch);
      this.isLoading = false;
    }
  }
}
